export default "__VITE_ASSET__DEZbZqyE__"